const KL_GALLERY_PAGINATION_SELECTOR = '[data-kl-gallery-pagination]';
const KL_GALLERY_DOT_SELECTOR = '[data-kl-gallery-dot]';
const KL_GALLERY_SLIDE_SELECTOR = '[id^="Slide-"]';

function getSlideScrollPosition(slide, firstSlide) {
  return slide.offsetLeft - firstSlide.offsetLeft;
}

function setActiveDot(dots, activeIndex) {
  dots.forEach((dot, index) => {
    const isActive = index === activeIndex;

    dot.classList.toggle('is-active', isActive);

    if (isActive) {
      dot.setAttribute('aria-current', 'true');
    } else {
      dot.removeAttribute('aria-current');
    }
  });
}

function trimDots(dots, slideCount) {
  dots.forEach((dot, index) => {
    dot.toggleAttribute('hidden', index >= slideCount);
  });
}

function initGalleryPagination(pagination) {
  if (!pagination || pagination.dataset.klGalleryPaginationReady === 'true') return;

  const slider = document.getElementById(pagination.dataset.klGalleryPaginationSlider || '');

  if (!slider) {
    console.debug('kl-gallery: the pagination could not find its slider', {
      sliderId: pagination.dataset.klGalleryPaginationSlider,
    });
    return;
  }

  const dots = Array.from(pagination.querySelectorAll(KL_GALLERY_DOT_SELECTOR));

  if (dots.length === 0) return;

  pagination.dataset.klGalleryPaginationReady = 'true';

  const getSlides = () => Array.from(slider.querySelectorAll(KL_GALLERY_SLIDE_SELECTOR));

  trimDots(dots, getSlides().length);
  setActiveDot(dots, 0);

  slider.addEventListener('slideChanged', (event) => {
    const currentPage = Number.parseInt(event.detail?.currentPage, 10);

    if (!Number.isFinite(currentPage)) return;

    trimDots(dots, getSlides().length);
    setActiveDot(dots, currentPage - 1);
  });

  pagination.addEventListener('click', (event) => {
    const dot = event.target.closest(KL_GALLERY_DOT_SELECTOR);

    if (!dot) return;

    try {
      const slides = getSlides();
      const index = Number.parseInt(dot.dataset.klGalleryDotIndex, 10);
      const target = slides[index];

      if (!target || !slides[0]) return;

      slider.querySelector('[id^="Slider-"]')?.scrollTo({
        left: getSlideScrollPosition(target, slides[0]),
        behavior: 'smooth',
      });
    } catch (error) {
      console.debug('kl-gallery: could not move to the chosen slide', {
        index: dot.dataset.klGalleryDotIndex,
        error,
      });
    }
  });
}

document.querySelectorAll(KL_GALLERY_PAGINATION_SELECTOR).forEach(initGalleryPagination);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_GALLERY_PAGINATION_SELECTOR).forEach(initGalleryPagination);
});
